import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { enviroments } from 'utils/constants';

export const categoryServiceApi = createApi({
  reducerPath: 'categoryServiceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: enviroments.endPoint,
    prepareHeaders: (headers, { getState, endpoint }) => {
      headers.set(
        'Authorization',
        'Bearer ' + JSON.parse(localStorage.getItem('userAccountInformation') || '{}').bearerToken,
      );
      return headers;
    },
  }),
  endpoints: (builder) => ({
    GetCategory: builder.query<any, string>({
      query: (language='es') => `poi/category/?locale=${language}`,
    }),
  }),
});

export const { useLazyGetCategoryQuery } = categoryServiceApi;
